/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Presentation_Template_Master_RemovedInputs */



/**
* | output |
* | --- |
* | "Template file removed. Downloads use the built-in design again." |
*
* @param {Presentation_Template_Master_RemovedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_template_master_removed = /** @type {((inputs?: Presentation_Template_Master_RemovedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Template_Master_RemovedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorlagendatei entfernt. Downloads nutzen wieder das eingebaute Design.")
	return /** @type {LocalizedString} */ ("Template file removed. Downloads use the built-in design again.")
});